import { useSelector } from "react-redux";
import DailyEarningGaps from "./DailyEarningGaps";
import MonthlyEarningGaps from "./MonthlyEarningGaps";
import AnomaliesSkeleton2 from "../../AnomaliesSkeleton2";

const AnomaliesEarnings = () => {
  const isFetchedForEarningData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForEarningData,
  );
  return (
    <>
      {isFetchedForEarningData ? (
        <>
          <DailyEarningGaps />
          <MonthlyEarningGaps />
        </>
      ) : (
        <AnomaliesSkeleton2 />
      )}
    </>
  );
};

export default AnomaliesEarnings;
